import ua from '@xl/user-agent';

// 统一的端类型判断入口，避免 ClientUtil.isXxx() 与 ua.parse() 两套写法并存
const { isIOS, isAndroid, isHarmony } = ua.parse() as any;

/**
 * 原始系统类型（保留鸿蒙）: 'ios' | 'android' | 'harmony'
 */
export const clientSystem: 'ios' | 'android' | 'harmony' = isAndroid
  ? 'android'
  : isHarmony
    ? 'harmony'
    : 'ios';

/**
 * 页面展示/埋点常用：android(含harmony) / ios
 */
export const clientType = clientSystem;

/**
 * 接口字段常用：1001(android/harmony) / 1002(ios)
 */
export const clientTypeCode = clientSystem === 'ios' ? 1002 : 1001;

/**
 * 鸿蒙的业务逻辑与安卓一致，统一使用该判断
 */
export const isAndroidOrHarmony = !!(isAndroid || isHarmony);

/**
 * 是否在端内（已知的原生平台：iOS / Android / Harmony）
 */
export const isInApp = !!(isIOS || isAndroid || isHarmony);
